import { StatusPage } from '@data/components/composite/StatusPage/StatusPage';
import cliffordWrong from '@data/assets/clifford-wrong.png';

export function DataIssuePage() {
  return (
    <StatusPage
      heading="Something went wrong"
      description={
        <>
          <p>We were unable to load this page.</p>
          <p>Try refreshing the page or clearing your cookies.</p>
        </>
      }
      illustration={cliffordWrong}
    />
  );
}
